import React, { HTMLAttributes, ReactNode } from 'react'
import { MapPin } from 'react-feather'

import { Span } from '@frame/ui-primitives/span'

import { cn } from '@frame/lib/utils/cn'
import { DataAttribute } from '@frame/types'
import { ListboxOption } from '@headlessui/react'

import { LoadingSpinner } from '../loading-spinner'
import { AddressInfo } from './types'

type Props = {
  isLoading: boolean
  results: AddressInfo[]
}

export function Results({ isLoading, results }: Props) {
  if (isLoading) {
    return (
      <ResultsContainer className="justify-center">
        <LoadingSpinner />
      </ResultsContainer>
    )
  }

  if (!results?.length) {
    return (
      <ResultsContainer>
        <p className="px-3 py-2 text-sm font-medium text-moss-700">No results found</p>
      </ResultsContainer>
    )
  }

  return (
    <ResultsContainer className={cn('flex-col items-start justify-start', results.length === 1 && 'justify-center')}>
      {results.map((address) => (
        <ListboxOption
          as="li"
          className="group flex w-full cursor-pointer items-center px-2 py-3 text-sm text-moss-700 transition-colors hover:bg-electric-100"
          key={address?.place_id}
          value={address}
        >
          <MapPin className="mr-2 h-4 w-4 flex-shrink-0 text-moss-500" />
          <Span className="transition-colors group-hover:text-moss-950">{address.description}</Span>
        </ListboxOption>
      ))}
    </ResultsContainer>
  )
}

function ResultsContainer({
  children,
  className,
}: {
  children: ReactNode
  className?: HTMLAttributes<HTMLElement>['className']
}) {
  return (
    <div
      data-cy={DataAttribute.ADDRESS_OPTIONS}
      className={cn(
        'mt-2 flex max-h-[172px] min-h-[64px] items-center overflow-y-scroll rounded-sm border-1.5 bg-white py-2',
        className
      )}
    >
      {children}
    </div>
  )
}
